// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-withdrawn[data-v-d8517222]{\n  background-color:#f2f2f2 !important;\n  color: #717986 !important;\n}\n", ""]);
// Exports
module.exports = exports;
